import { render, staticRenderFns } from "./app-header.vue?vue&type=template&id=03a38048&scoped=true&"
import script from "./app-header.vue?vue&type=script&lang=ts&"
export * from "./app-header.vue?vue&type=script&lang=ts&"
import style0 from "./app-header.vue?vue&type=style&index=0&id=03a38048&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a38048",
  null
  
)

export default component.exports